import React from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import {ReactComponent as HandClick} from './files/HandClick.svg';

export default (props) => <SvgIcon component={HandClick} {...props} />;
